import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { resource } from '@util/resource';
import { DWS } from '@interfaces/dws';

@Injectable({
  providedIn: 'root'
})
export class LanguagesService {

  constructor() {
  }

  list(): Observable<DWS.Page<DWS.Language>> {
    return resource('crm://languages')
      .params(
        { page: 0, count: 9999 }
      )
      .get<DWS.Page<DWS.Language>>();
  }
}
